import {ChevronDown, ChevronRight, ChevronUp} from "lucide-react";
import React, {useState} from "react";
import {Link} from "react-router-dom";
import {breadCrumbsDelimiter} from "../Utils/SimmsUtils";
import {getFistPage} from "../commonmethod/CommonMethod";
import {addHeaderTab} from "../pageTabs/pageTabsStorage";

export function ButtonMenu({
    data,
    depth = 0,
    menuName,
    topIcon,
    setGlobalClickedMenuId,
    globalClickedMenuId,
    isFlatMenu = false,
}) {
    const findInitiallyOpenMenus = (data) => {
        let initiallyOpenMenus = [];

        const traverseMenu = (menu) => {
            if (menu.children && menu.children.length > 0) {
                menu.children.forEach(traverseMenu);
            }
        };
        data.forEach(traverseMenu);

        return initiallyOpenMenus;
    };
    const initiallyOpenMenus = findInitiallyOpenMenus(data);
    const [expandedMenus, setExpandedMenus] = useState(
        initiallyOpenMenus.reduce((acc, menuId) => ({...acc, [menuId]: true}), {})
    );

    const isNoUrlParent = (menu) => !menu.url && menu.children?.length > 0;
    /** 3뎁스: 사이드바 2·3뎁스( depth≥1 ) 링크만 소메뉴. 2뎁스 Top(대시보드): 사이드바 1뎁스 링크는 중메뉴 */
    const isSubMenuLink = (menu) => Boolean(menu.url && (!isFlatMenu || depth > 0));

    const toggleSubMenu = (menuId) => {
        const target = data.find((menu) => menu.id === menuId);
        setExpandedMenus((prevState) => {
            if (prevState[menuId]) {
                return {...prevState, [menuId]: false};
            }
            const next = {...prevState, [menuId]: true};
            if (target && isNoUrlParent(target)) {
                data.forEach((menu) => {
                    if (menu.id !== menuId && isNoUrlParent(menu)) {
                        next[menu.id] = false;
                    }
                });
            }
            return next;
        });
    };

    const handleClick = (menuId, menu) => {
        setGlobalClickedMenuId(menuId);
        if (menu?.url) {
            addHeaderTab({title: menu.name, url: menu.url, icon: topIcon});
        }
    };

    getFistPage();

    return (
        <ul className={`sidebar-menu indent-${depth}`}>
            {data.map((menu) => (
                <li
                    key={`${menu.id}_${depth}`}
                    id={menu.eng}
                    className={isSubMenuLink(menu) ? "sub-menu-li" : ""}
                >
                    {menu.url ? (
                        isSubMenuLink(menu) ? (
                            <Link
                                to={menu.url}
                                className="flex"
                                state={{test: menuName + breadCrumbsDelimiter() + menu.name}}
                                onClick={() => {
                                    handleClick(menu.id, menu);
                                    toggleSubMenu(menu.id);
                                }}
                            >
                                <div
                                    variant="ghost"
                                    className={`top-menu menu hover-gray sub-menu w-full py-2 pl-2 ${globalClickedMenuId === menu.id ? "menu-clicked" : ""}`}
                                >
                                    <span style={{paddingLeft: `${(depth - 1) * 15}px`}}>
                                        {menu.name}
                                    </span>
                                </div>
                            </Link>
                        ) : (
                            <Link
                                to={menu.url}
                                className="flex"
                                state={{test: menuName + breadCrumbsDelimiter() + menu.name}}
                                onClick={() => handleClick(menu.id, menu)}
                            >
                                <div
                                    className={`hover-gray simms-menu-btn menu flex w-full cursor-pointer line-height-45 px-2 ${globalClickedMenuId === menu.id ? "menu-clicked" : ""}`}
                                >
                                    {menu.name}
                                </div>
                            </Link>
                        )
                    ) : depth === 0 ? (
                        <div
                            id={menu.eng}
                            className={`hover-gray simms-menu-btn menu flex cursor-pointer line-height-45 px-2 ${expandedMenus[menu.id] ? "menu-opened" : ""}`}
                            onClick={() => toggleSubMenu(menu.id)}
                        >
                            {menu.name}
                            {expandedMenus[menu.id] ? (
                                <ChevronUp className="mr-[0.3rem] mt-[10px] w-5" />
                            ) : (
                                <ChevronDown className="mr-[0.3rem] mt-[10px] w-5" />
                            )}
                        </div>
                    ) : (
                        <Link
                            to={menu.url}
                            className="flex cursor-pointer border-b bg-[#f9f9f9]"
                            state={{test: menuName + breadCrumbsDelimiter() + menu.name}}
                            onClick={() => {
                                handleClick(menu.id, menu);
                                toggleSubMenu(menu.id);
                            }}
                        >
                            <div
                                variant="ghost"
                                className={`top-menu menu sub-menu flex items-center line-height-35 ${globalClickedMenuId === menu.id ? "menu-clicked" : ""}`}
                            >
                                {menu.name}
                                {expandedMenus[menu.id] ? (
                                    <ChevronDown className="ml-[0.3rem] w-3" />
                                ) : (
                                    <ChevronRight className="ml-[0.3rem] w-3" />
                                )}
                            </div>
                        </Link>
                    )}
                    {expandedMenus[menu.id] && menu.children && menu.children.length > 0 && (
                        <ButtonMenu
                            data={menu.children}
                            depth={depth + 1}
                            menuName={menuName + breadCrumbsDelimiter() + menu.name}
                            topIcon={topIcon}
                            setGlobalClickedMenuId={setGlobalClickedMenuId}
                            globalClickedMenuId={globalClickedMenuId}
                            isFlatMenu={isFlatMenu}
                        />
                    )}
                </li>
            ))}
        </ul>
    );
}
